define('presentation/settings/webChats/presentationObjects/webChatWidgetPresentationObject',[], function() {
    return function(){
        const self = this;

        self.webChatWidgetId = null;
        self.displayName = null;
        self.launcherTextColor = null;
        self.launcherBackgroundColor = null;
        self.welcomeMessage = null;
        self.liveReceptionistScriptId = null;
        self.authorizedDomains = [];
        self.editWebChatWidgetUrl = null;
    };
});

